import React from 'react';
import { useEffect, useState } from "react";
import apiAdm from "../../../services/apiAdm.js";
import apiAcbr from "../../../services/apiAcbr.js";
import Menu from "../../../components/menu/menu.jsx";
import DataTable from "react-data-table-component";
import '../../../style/global.css';
import {  FiRefreshCcw, FiMoreVertical, FiFilter } from "react-icons/fi";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Spinner from 'react-bootstrap/Spinner';
import Form from 'react-bootstrap/Form';

function NFCe() {
  const [pageSize, setPageSize] = useState(10);
  const [dados, setDados] = useState([]);
  const [idEntidade, setEntidade] = useState(localStorage.getItem('idEmpresa'));
  const [EditaId, setEditaId] = useState(0);
  const [totalRegistros, setTotalRegistros] = useState(0);
  const [loading, setLoading] = useState(false);

  //Filtro
  const [status, setStatus] = useState([]);
  const [idStatus, setIDStatus] = useState([]);
  const [manifestos, setManifestos] = useState([]);
  const [idManifesto, setIDManifesto] = useState([]);
  const [nomeDestina, setNomeDestina] = useState('');
  const [valorDe, setValorDe] = useState('');
  const [valorAte, setValorAte] = useState('');
  const [dataDe, setDataDe] = useState('');
  const [dataAte, setDataAte] = useState('');
  const [numeroNota, setNumeroNota] = useState('');
  const [chave, setChave] = useState('');

  const [showModalSefaz, setShowModalSefaz] = useState(false);
  const [showModalMaisInfo, setShowModalMaisInfo] = useState(false);
  const [showModalChave, setShowModalChave] = useState(false);

  const [infoID, setInfoID] = useState('');
  const [infoDestina, setInfoDestina] = useState('');
  const [infoChave, setInfoChave] = useState('');

  const tableCustomStyles = {
    headRow: {
      style: {
        color: 'white',
        backgroundColor: '#6571ff'
      },
    },

  };

  const columns = [

    {
      name: 'Status',
      cell: row =>
        <>
          {row.idStatus == 4 ?
            <span className="badge bg-danger">{row.statusNome}</span> :
            <span className="badge bg-success">{row.statusNome}</span>}
        </>,
      sortable: true,
      width: "8%",
    },

    {
      name: 'Cliente',
      selector: row => row.nome,
      sortable: true,
      width: "50%",
    },
    {
      name: 'Emissão',
      selector: row => row.dhEmi,
      sortable: true,
      wrap: true,

      width: "10%",
      format: row => new Intl.DateTimeFormat('pt-BR',
        {
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
          // hour: 'numeric',
          // minute: 'numeric',
        }).format(new Date(row.dhEmi)),
      center: true
    },
    {
      name: 'Valor',
      selector: row => row.vNF,
      sortable: true,
      right: true,
      width: "15%",
      format: row => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(row.vNF)
    },
    {
      name: 'Nro Nota',
      selector: row => row.nNF,
      sortable: true,
      width: "9%",
    },

    {
      name: 'Ações',
      cell: (row) => <>

        <button type="button" style={{ height: '26px', width: '26px' }} className='btn btn-sm btn-icon btn-outline-primary rounded-circle mr-2' data-bs-toggle="dropdown"
          aria-haspopup="true" aria-expanded="false">
          <FiMoreVertical />
        </button>
        <div className="dropdown-menu" aria-labelledby="btnGroupDrop1">
          <a onClick={() => Danfe(row.id)} className="dropdown-item"
            href="#">Imprimir Danfe</a>
          <a onClick={() => downloadXML(row.id)} className="dropdown-item"
            href="#">Download xml</a>
          <a onClick={() => maisInfo(row.id, row.nome, row.chave)} className="dropdown-item"
            href="#">Mais informações</a>
        </div>
      </>,


      width: "8%",        // width: "150px",
      center: true
    }
  ];


  const paginationOptions = {
    rowsPerPageText: 'Registros por página',
    rangeSeparatorText: 'de',
    selectAllRowsItem: false,
    selectAllRowsItemText: 'Todos'
  };

  function Listar(pageSize, page) {

    setValorAte(valorDe);

    const tipo = 'S';
    const xmlTipo = 5;
    setLoading(true);
    apiAdm.get("/xmlresumo",
      {
        params: {
          idEntidade, tipo, xmlTipo, idStatus, idManifesto, nomeDestina,
          dataDe, dataAte, valorDe, valorAte, numeroNota, chave, page, pageSize
        }
      }
    )
      .then((resp) => {
        setTotalRegistros(resp.data.count);
        setDados(resp.data.data);
        setLoading(false);
      })
      .catch((err) => {
        setTotalRegistros(0);
        setDados([]);
        alert("Erro ao carregar NFC-e");
      });
  }

  useEffect(() => {
    ComboStatus();
    Listar(pageSize, 1);

  }, []);

  function ChangePerRows(newQtd, page) {
    Listar(newQtd, page);
    setPageSize(newQtd);
  }

  function ChangePage(newPage) {
    Listar(pageSize, newPage);
  }

  function ComboStatus() {
    apiAdm.get("/statusResumo")
      .then((resp) => {
        console.log(resp.data.data);
        setStatus(resp.data.data);
      })
      .catch((err) => {
        setStatus([]);
        alert("Erro ao montar Status");
      });
  };


  function ChangeStatus(e) {
    setIDStatus(e.target.value);
  }

  function limparFiltro() {
    setIDStatus([]);
    setNomeDestina('');
    setValorDe('');
    setValorAte('');
    setDataDe('');
    setDataAte('');
    setNumeroNota('');
    setChave('');
  };


  function closeModalMaisInfo() {
    setShowModalMaisInfo(false);
  }

  function maisInfo(id, nome, chave) {
    setInfoID(id);
    setInfoDestina(nome);
    setInfoChave(chave);
    setShowModalMaisInfo(true);
  };

  return <>
    <div className="container-fluid">
      <div className="row flex-nowrap">
        <div className="col-auto col-md-3 col-xl-2 px-sm-2 px-0"></div>
        <div className="row">
          <div className="col-md-10 py-3">
            <div className="card">
              <div className="card-body">
                <h4 className="text-muted mb-3">Nota fiscal eletrônica ao Consumidor - NFC-e</h4>


                {/* Filtro */}
                <div className="accordion" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingOne">
                      <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne"
                        aria-expanded="false" aria-controls="collapseOne">
                        Filtro
                      </button>
                    </h2>
                    <div id="collapseOne" className="accordion-collapse collapse" aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample">
                      <div className="accordion-body">
                        <div className="row mb-3">
                          <div className="col-sm-3">
                            <label for="selectStatus" className="text-secondary">Status</label>
                            <select className="form-select" name="status_select" id="selectStatus" onChange={ChangeStatus}>
                              <option value="">Todos os status</option>
                              {
                                status.map((item) => {
                                  return <option key={item.id} value={item.id}>{item.nome}</option>
                                })
                              }
                            </select>
                          </div>

                          <div className="col-sm-9">
                            <label className="text-secondary">Cliente</label>
                            <input type="text" className="form-control" onChange={(e) => setNomeDestina(e.target.value)} value={nomeDestina} />
                          </div>
                        </div>

                        <div className="row mb-3">
                          <div className="col-sm-2">
                            <label className="text-secondary">A partir da emissão</label>
                            <input type="date" className="form-control" onChange={(e) => setDataDe(e.target.value)} value={dataDe} />
                          </div>
                          <div className="col-sm-2">
                            <label className="text-secondary">Até a emissão</label>
                            <input type="date" className="form-control" onChange={(e) => setDataAte(e.target.value)} value={dataAte} />

                          </div>
                          <div className="col-sm-2">
                            <label className="text-secondary">Valor</label>
                            <input type="number" className="form-control" onChange={(e) => setValorDe(e.target.value)} value={valorDe} />

                          </div>
                          <div className="col-sm-2">
                            <label className="text-secondary">Nro Nota</label>
                            <input type="text" className="form-control" onChange={(e) => setNumeroNota(e.target.value)} value={numeroNota} />
                          </div>
                          <div className="col-sm-4">
                            <label className="text-secondary">Chave de acesso</label>
                            <input type="text" className="form-control" onChange={(e) => setChave(e.target.value)} value={chave} />
                          </div>
                        </div>

                        <div className="row mb-3">
                          <div className="btn-opcoes col-md-12" style={{ textAlign: 'right' }}>

                            <button type="button" className="btn btn-outline-secondary" style={{ marginRight: 8 }}
                              onClick={() => limparFiltro()}>
                              <FiRefreshCcw /><span> Limpar filtro </span>
                            </button>
                            <button type="button" className="btn btn-primary  mr-2"
                              onClick={() => Listar()}>
                              <FiFilter /><span> Filtrar </span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>


                {/* Mais Informações */}
                <Modal
                  show={showModalMaisInfo} onHide={closeModalMaisInfo}
                  size="lg"
                  aria-labelledby="contained-modal-title-vcenter"
                  centered
                >
                  <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                      Mais informações
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Form>
                      <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                        <Form.Label>#ID</Form.Label>
                        <p>{infoID}</p>
                      </Form.Group>
                      <Form.Group className="mb-3">
                        <Form.Label>Destinatário</Form.Label>
                        <p>{infoDestina}</p>
                      </Form.Group>
                      <Form.Group className="mb-3">
                        <Form.Label>Chave de acesso</Form.Label>
                        <p>{infoChave}</p>
                      </Form.Group>
                    </Form>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button onClick={closeModalMaisInfo}>Fechar</Button>
                  </Modal.Footer>
                </Modal>

                {/* Tabela */}
                <br></br>

                <DataTable className="dataTables_wrapper"
                  columns={columns}
                  data={dados}
                  pagination={true}
                  paginationComponentOptions={paginationOptions}
                  noDataComponent={loading ? <Spinner animation="border" variant="primary" /> :
                    <p className="no-data-found">Nenhum registro encontrado</p>
                  }

                  paginationServer={true}
                  paginationTotalRows={totalRegistros}
                  highlightOnHover
                  pointerOnHover
                  dense
                  onChangeRowsPerPage={ChangePerRows}
                  onChangePage={ChangePage}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </>
}


async function Danfe(id) {

  await apiAdm.get("/xmlresumo/" + id,
  )
    .then(async (resp) => {
      let json = {
        status: resp.data.data.idStatus,
        chave: resp.data.data.chave,
        cnpj: localStorage.getItem('cnpjEmpresa'),
        idEmpresa: localStorage.getItem('idEmpresa'),

        casaQtda: 2,
        casaPreco: 2
      };
      await apiAcbr.post('/NFe/ImprimirCTe', json)
        .then((resp2) => {
          window.open(resp2.data.urlPdf);
        })
        .catch((err2) => {
          console.log(err2);
        })
    })
    .catch((err) => {
      alert("Erro ao carregar o CTe. " + err);
    });
};


async function downloadXML(id) {
  await apiAdm.get("/xmlresumo/" + id,
  )
    .then(async (resp) => {
      let json = {
        status: resp.data.data.idStatus,
        chave: resp.data.data.chave,
        cnpj: localStorage.getItem('cnpjEmpresa'),
        idEmpresa: localStorage.getItem('idEmpresa'),
        casaQtda: 2,
        casaPreco: 2
      };
      await apiAcbr.post('/NFe/ImprimirCTe', json)
        .then((resp2) => {
          window.open(resp2.data.urlXml);
        })
        .catch((err2) => {
          console.log(err2);
        })
    })
    .catch((err) => {
      alert("Erro ao carregar o CTe. " + err);
    });

};

function atualizarChave() {
}


export default NFCe;